
import { menuService } from '../services/menuService';
import React from 'react';
import ReactDOMServer from "react-dom/server";
import QueryString from 'querystring';
import { langService } from '../services/langService';
import { catalogService } from '../services/catalogService';
import { makeApiUrl } from '../helpers/makeApiUrl';
import { authHeader } from '../helpers/authHeader';
import { Link } from 'react-router-dom'
import { handleResponse } from '../helpers/handleResponse';
import { connect, Provider } from 'react-redux';
import qs from 'query-string';
import {_t} from './../i18n/lang'
import PerfectScrollbar from 'react-perfect-scrollbar';


import './../css/category.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faDesktop,
    faMobileAlt,
    faCameraRetro,
    faPlug,
    faPrint,
    faLightbulb,
    faBaby, faDumbbell, faServer, faTv, faTools, faBell, faFillDrip, faHome, faQuestion, faAngleDown, faAngleUp
} from '@fortawesome/free-solid-svg-icons'

import {getLocation} from './../helpers/getLocation'


 class CategoryMenu extends React.Component {
	constructor (props) {
		super(props);
        const query = getLocation.search

        this.state = {
            type: (query.mi && query.mi.charAt(0)=='p') ? 'by-prod' : 'by-cat' ,
            search: '',
        };
        this.handleClick            = this.handleClick.bind(this);
        this.handleChangeSearch     = this.handleChangeSearch.bind(this)
        
    }
    
    handleClick(type, e) {
        this.setState({ type: type , search: '' });
        e.preventDefault();
    }
        
    handleChangeSearch(event) {
        let v = event.target.value;
        this.setState({search: v});
          
    }

	render(){
		return (

            <div className="side-bar-menu-type">
                <ul className="nav nav-justified side-bar-menu-head" role="tablist">
                    <li className="nav-item">
                        <a className={"nav-link menu-nav-link "+(this.state.type=='by-cat' ? 'active' : '')} onClick={(e) => this.handleClick('by-cat', e)}  >{_t('CATMENU_CATEGORY')}</a>
                    </li>
                    <li className="nav-item">
                        <a className={"nav-link menu-nav-link "+(this.state.type=='by-prod' ? 'active' : '')} onClick={(e) => this.handleClick('by-prod', e)}  >{_t('CATMENU_PRODUCER')}</a>
                    </li>
                </ul>
                <div className="tab-content" style={{padding:"1rem 0"}}>
                    <div className="form-group md-form mt-0 waves-light category-menu-container-search ">
                        <input type="text" className="form-control category-menu-search" placeholder={_t('CATMENU_SEARCH')} value={this.state.search} onChange={this.handleChangeSearch}/>
                    </div>
                    <hr/>
                    <div className="tab-pane fade in show active" id="menucat" role="tabpanel">
                        <MenuType type={this.state.type} search={this.state.search} lang={this.props.lang} addr={this.props.addr} sort={this.props.sort} view={this.props.view} onStock={this.props.onStock} onUpdateSize={this.props.onUpdateSize} />
                    </div>
                </div>               
            </div>
        );
	}

}



class DataParser {
    constructor() {
        this.data   = {} 
        this.parents = []
        this.childrens = []
        this.search = [] 
    }

    makeParents(items, metaId, parents, parent) {

        Object.keys(items).map((key, index) => {
            let item    = items[key]
            let n       = item.n.toUpperCase()
            let hash    = metaId+'.'+key

            if (!this.search[n]) {
                this.search[n] = []
            }
             if (!this.childrens[parent]) {
                this.childrens[parent] = []
            }
            this.search[n].push(hash)
            this.childrens[parent].push(hash)
            this.parents[hash] = parents        
            if (item.i) {
                let newParents = [...parents]
                newParents.push(hash)
                this.makeParents(item.i, (metaId > 0 ? metaId : key), newParents, hash)
            }
        })

    }

    getParents(id) {
        return (this.parents[id] ? this.parents[id] : [])
    }

    getChildrens(id) {
        return (this.childrens[id] ? this.childrens[id] : [])
    }

    haveChildren(id) {
        return this.childrens[id] ? true : false
    }

    getChildrensFamily(id, family) {

        this.getChildrens(id).map((children) => {
            family[children] = 1
            if (this.haveChildren(children)) {
                family = this.getChildrensFamily(children, family)
            }
        })
        return Object.keys(family)
    }

    loadData(data) {
        this.data = data
        this.makeParents(data, 0, [], 0)
    }

    replaceLabel(label, q) {
        if (!q || q=='') {
            return label
        }
        var re = new RegExp(q,"gi");
        return label.replace(re, '<b>'+q+'</b>')
    }

    find(q) {

        if (!q || q=='') {
            return 'all'
        }
        let matched_nodes   = [];
        let allowed_nodes   = [];

        q  = q.trim().toUpperCase();



        Object.keys(this.search).map((key, index) => {
            if (key.toUpperCase().indexOf(q) > -1) { 
                matched_nodes.push(this.search[key])
            };
        })

        matched_nodes.map((items) => {
            items.map((item) => {

                allowed_nodes[item]=1
                this.parents[item].map((node) => {
                    allowed_nodes[node]=1
                })
                if (this.haveChildren(item)) {
                    this.getChildrensFamily(item, []).map((node) => {
                        allowed_nodes[node]=1
                    })
                }
            })
        })
        return Object.keys(allowed_nodes)
        
    }
}


const Parser = new DataParser()
const  LoadingComponent = () => (<span>....</span>)

/**
* Komponent MENU
*/
 class MenuType extends React.Component {

	constructor (props) {
		super(props);

		this.state = {
            allowed: 'all',
            useCache: false,
            type: props.type,
			loading: true,
		};

    }
    
        
        
    componentDidUpdate(prevProps, prevState) {     
        // ladujemy produkt
        if(prevProps.type !== this.props.type || prevProps.lang !== this.props.lang ){
            this.setState({type: this.props.type, search:this.props.search});
            this.loadData(this.props.type, this.props.search, this.props.lang,  this.props.addr);
        }
    }
        
	componentDidMount() {
		// ladujemy produkt
		this.loadData(this.props.type, this.props.search,  global.lang,  this.props.addr);
	}        


	loadData(menuType, q, lang, addr)  {
		this.setState({ loading:true});
               
		let url = makeApiUrl('catalog/groups-menu');
		let cache = menuService.get(menuType, lang, addr);


		if (this.state.useCache && cache ) {                 
            Parser.loadData(cache)
			this.setState({loading:false, allowed: Parser.find(q)});
		} else {
            let data = new FormData();
            data.append('type', menuType);

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: data
            };
			fetch(url, requestOptions)
			.then(handleResponse)
			.then(json => {
				menuService.set(menuType, lang, addr, json)				
                Parser.loadData(json.items)
				this.setState({loading:false, allowed: Parser.find(q), items: json.items});
			});
		}
	}
	


	render() {
			return (
            this.state.loading ? <LoadingComponent/> : <div id="category-menu-container">
               <NewMenu items = {this.state.items} handleClick={this.handleClick} active={this.state.active} type={this.state.type} q={this.props.search} onUpdateSize={this.props.onUpdateSize}/>
            </div>
        );
	}
		

}


class NewMenu extends React.Component {

    constructor (props) {
        super(props);
        const query = getLocation.search
        const mi    =  query['mi'] ? query['mi'].split('_') : null;
        const group = mi ? mi[0].substring(1) : 0;
        const category = mi ? mi[1] : 0;


        this.state = {
            activeGroup: group,
            activeCategory: category,
            activeHash: group+'.'+category,
            locationSearch: getLocation.search
        };      

        this.handleClick = this.handleClick.bind(this);
        this.getIcon = this.getIcon.bind(this)
    }
    
    componentDidUpdate(prevProps, prevState) {     
        // ladujemy produkt
        const query = getLocation.search
        const mi    =  query['mi'] ? query['mi'].split('_') : null;
        const group = mi ? mi[0].substring(1) : 0;
        const category = mi ? mi[1] : 0;

        if( this.state.locationSearch != getLocation.search ){

            this.setState({activeGroup: group, activeCategory: category, activeHash: group+'.'+category, locationSearch: getLocation.search });
            
        }
    }

    handleClick(group, category, e) {
        //jesli kliknieto drugi raz zwijamy menu

        this.setState(state => ({
            activeGroup: group,
            activeCategory: category,
            activeHash: group+'.'+category
        }), () => {this.props.onUpdateSize()});
        e.preventDefault();
    }

    getIcon(id) {


        switch (id) {
            case '1':
                return <FontAwesomeIcon icon={faDesktop} className="category-icon"/>;
            case '2':
                return <FontAwesomeIcon icon={faMobileAlt} className="category-icon"/>;
            case '3':
                return <FontAwesomeIcon icon={faCameraRetro} className="category-icon"/>;
            case '4':
                return <FontAwesomeIcon icon={faPlug} className="category-icon"/>;
            case '5':
                return <FontAwesomeIcon icon={faPrint} className="category-icon"/>;
            case '6':
                return <FontAwesomeIcon icon={faLightbulb} className="category-icon"/>;
            case '7':
                return <FontAwesomeIcon icon={faBaby} className="category-icon"/>;
            case '8':
                return <FontAwesomeIcon icon={faDumbbell} className="category-icon"/>;
            case '9':
                return <FontAwesomeIcon icon={faTools} className="category-icon"/>;
            case '10':
                return <FontAwesomeIcon icon={faServer} className="category-icon"/>;
            case '11':
                return <FontAwesomeIcon icon={faTv} className="category-icon"/>;
            case '12':
                return <FontAwesomeIcon icon={faBell} className="category-icon"/>;
            case '13':
                return <FontAwesomeIcon icon={faFillDrip} className="category-icon"/>;
            case '14':
                return <FontAwesomeIcon icon={faHome} className="category-icon"/>;
            default:
                return <FontAwesomeIcon icon={faQuestion} className="category-icon"/>;
                break;

        }
    }


    sortItems(items) {
        const f = (a, b) => {
            let s1  =  parseInt(a.s)
            let s2  =  parseInt(b.s)
            if (s1 < s2) return -1;
            if (s1 > s2) return 1;
            if (s1 == s2) {
                if (a.n > b.n) return 1
                return -1
            }
            return 0
        }
        let ret = []

        return ret

        Object.keys(items).map(function(key, index){
            let item = items[key]
            item.id = key
            ret.push(item)
        })

        return ret.sort(f)
    }


    renderItem(items,  group) {
        let ret = []

        let allowed = Parser.find(this.props.q)
        let parents = Parser.getParents(this.state.activeHash)
        let openAll = allowed != 'all' && allowed.length < 100 ? true : false

        this.sortItems(items).map((item, index) => {
            let key = item.id
            let hash = group+'.'+key

            if (allowed != 'all' && allowed.indexOf(hash) == -1) return;
            if (item.i) {
                let subMenu = (hash == this.state.activeHash || parents.indexOf(hash) > -1 || openAll) ? <ul>{(this.renderItem(item.i,  (group > 0 ? group : key)))}</ul> : ''
                let icon = ReactDOMServer.renderToString(subMenu ? <FontAwesomeIcon icon={faAngleUp} className="rotate-icon"/>  : <FontAwesomeIcon icon={faAngleDown} className="rotate-icon"/>);
                let className = ( (key == this.state.activeGroup || key == this.state.activeCategory) && group ==  0) ? 'activeGroup' : ''
                let categoryIcon = (group == 0 && this.props.type == 'by-cat' )  ? ReactDOMServer.renderToString(this.getIcon(key)) : '<i class="category-icon"></i>'
                let title = categoryIcon+Parser.replaceLabel(item.n, this.props.q)+icon

                ret.push(<li key={key} ><a href="#" t={hash} onClick={(e) => this.handleClick(group, key, e)}  className={className+" arrow-r"} dangerouslySetInnerHTML={{__html: title}}></a>{subMenu}</li>)
            } else  {
                let icon = group == 0 ? '<i class="category-icon"></i>' : ''
                let activeClass = this.state.activeHash == hash ? 'active-menu-item' : '';
                ret.push(<li key={key} className=""><Link to={catalogService.generateUrlForMenu(key, this.props.type, group+'_'+key)}  dangerouslySetInnerHTML={{__html: icon+Parser.replaceLabel(item.n, this.props.q)}} className={activeClass}></Link></li>)
            }

        })

        return ret;
    }

    render() {
        const {items} = this.props
        let list =  this.renderItem(items,  0)

        return  <PerfectScrollbar><ul>{list}</ul></PerfectScrollbar>
    }

}




const mapState = (state) => {
  const { alert , user } = state;
  return { lang: user.lang, addr:user.addr };
};

export default connect(mapState, null)(CategoryMenu);